/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TaxRate
 */
export interface TaxRate {
    /**
     * 
     * @type {string}
     * @memberof TaxRate
     */
    name: string;
    /**
     * decimal rate like 0.20
     * @type {number}
     * @memberof TaxRate
     */
    rate: number;
    /**
     * 
     * @type {string}
     * @memberof TaxRate
     */
    type?: TaxRateTypeEnum;
}


/**
 * @export
 */
export const TaxRateTypeEnum = {
    Vat: 'VAT',
    Irpf: 'IRPF',
    Other: 'OTHER'
} as const;
export type TaxRateTypeEnum = typeof TaxRateTypeEnum[keyof typeof TaxRateTypeEnum];


/**
 * Check if a given object implements the TaxRate interface.
 */
export function instanceOfTaxRate(value: object): value is TaxRate {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('rate' in value) || value['rate'] === undefined) return false;
    return true;
}

export function TaxRateFromJSON(json: any): TaxRate {
    return TaxRateFromJSONTyped(json, false);
}

export function TaxRateFromJSONTyped(json: any, ignoreDiscriminator: boolean): TaxRate {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'rate': json['rate'],
        'type': json['type'] == null ? undefined : json['type'],
    };
}

export function TaxRateToJSON(value?: TaxRate | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'rate': value['rate'],
        'type': value['type'],
    };
}

